// extracted by mini-css-extract-plugin
module.exports = {"messageBanner":"MessageBanner_messageBanner__rgy_6","bannerContent":"MessageBanner_bannerContent__5H3x2"};